import React, { useState } from 'react';
import ListPage from '@components/common/layout/ListPage';
import PickupSettingSavePage from '@components/common/page/pickupSetting/PickupSettingSavePage';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import routes from '@routes';
import { getData, setData } from '@utils/localStorage';
import { Tabs } from 'antd';

import PickupDisplayDeviceListPage from '..';




const PickupDisplayDeviceTabPage = ({ tabKey, restaurantId, restaurant, serverDetail, savedFilter, onFilterChange }) => {
    const translate = useTranslate();
   
    const [activeTab, setActiveTab] = useState(() => {
        const savedTab = getData(routes.deviceTabsRestaurantListPage.keyActiveTab + tabKey);
        return savedTab || 'device';
    });

    return (
        <ListPage
            baseTable={
                <>
                    <Tabs
                        type="card"
                        destroyInactiveTabPane
                        onTabClick={(key) => {
                            if (key === activeTab) return;
                            setActiveTab(key);
                            setData(routes.deviceTabsRestaurantListPage.keyActiveTab + tabKey, key);
                        }}
                        activeKey={activeTab}
                        items={[
                            {
                                key: 'device',
                                label: translate.formatMessage(commonMessage.Device),
                                children: <PickupDisplayDeviceListPage
                                    tabKey={tabKey}
                                    restaurantId={restaurantId}
                                    restaurant={restaurant}
                                    serverDetail={serverDetail}
                                    savedFilter={savedFilter}
                                    onFilterChange={onFilterChange}
                                />,
                            },
                            {   
                                key: 'setting-device',
                                label: translate.formatMessage(commonMessage.setting),
                                children: <PickupSettingSavePage deviceId={serverDetail?.id}/>,
                            },
                        ]}
                    />
                </>
            }
        />
       
    );
};

export default PickupDisplayDeviceTabPage;
